import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { CniDevicesTable } from "@/features/cni-device-registry/components/CniDevicesTable"
import {
  cniDeviceStatusSchema,
  cniDeviceTypeSchema,
} from "@/features/cni-device-registry/schemas"

const searchSchema = z.object({
  id: z.string().optional(),
  type: cniDeviceTypeSchema.optional(),
  status: cniDeviceStatusSchema.optional(),
})

export const Route = createFileRoute("/_authed/cni/devices")({
  component: CniDevicesPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function CniDevicesPage() {
  const { t } = useTranslation("cni-devices")
  const { id, type, status } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <CniDevicesTable
        initialSelectedId={id ?? null}
        initialType={type ?? null}
        initialStatus={status ?? null}
      />
    </div>
  )
}
